export class Taxonomy {
    constructor(
        public id?: number,
        public name?: string,
        public hide?: boolean,
        public taxonomy_submit?: boolean) { }
}